var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDownSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94006 9.06229C7.526 9.64823 8.47756 9.64823 9.0635 9.06229L15.0635 3.06229C15.4947 2.63104 15.6213 1.98886 15.3869 1.42636C15.1526 0.863855 14.6088 0.49823 13.9994 0.49823L1.99944 0.502918C1.39475 0.502918 0.846311 0.868543 0.611936 1.43104C0.377561 1.99354 0.508811 2.63573 0.935373 3.06698L6.93537 9.06698L6.94006 9.06229Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownSolid);
export default __webpack_public_path__ + "static/media/caret-down-solid.4878b890a22f0f0804921a6ac0ae37a6.svg";
export { ForwardRef as ReactComponent };